<template>
    <div class="panel"
         :class="todo.done ? 'panel-default' : 'panel-primary'">
        <div class="panel-heading">
            {{ todo.attached_title }}
        </div>
        <div class="panel-body">
            <ul v-if="todo.info && todo.info.length">
                <li v-for="info of todo.info">
                    <strong>{{ infoTitle(info.slug) }}</strong>
                    {{{ formatInfo(info) }}}
                </li>
            </ul>

            <div class="cta-row">
                <loader v-if="doing"
                        :inline="true"></loader>

                <a @click.prevent="markDone()"
                   v-if="!todo.done"
                   class="btn btn-default">
                    Ignorer
                </a>

                <a @click.prevent="markDone(true)"
                   v-if="todo.done"
                   class="btn btn-danger">
                    Annuler
                </a>

                <template v-if="!todo.done">
                    <a v-link="{
                        name: 'contracts-edit',
                        params: {
                            id: client.id,
                            contractId: todo.attached_contract.id
                        }
                       }"
                       v-if="todo.source === 'subscription' || todo.source === 'ongoing-process'"
                       class="btn btn-primary">
                        Aller au contrat
                    </a>
                    <a v-link="{
                        name: 'contracts-edit',
                        params: {
                            id: client.id,
                            contractId: todo.attached_operation.contract
                        },
                        query: {
                            tab: 'operations'
                        }
                       }"
                       v-if="todo.source === 'operation'"
                       class="btn btn-primary">
                        Aller à l'opération
                    </a>
                    <a @click.prevent="openDocument()"
                       v-if="todo.source === 'document-expiring' ||
                        todo.source === 'document-validation'"
                       class="btn btn-primary">
                        Aller au document
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .cta-row {
        text-align: right;
    }

    .loader {
        margin-right: 10px;
    }

    .panel,
    .panel-body,
    .panel-heading {
        transition: 200ms all ease;
    }
</style>

<script type="text/ecmascript-6">
    import Vue from 'vue';
    import Loader from '../Loader';
    import {manager as msgManager} from '../../messages';
    import {
        markDone,
        updateCount,
        formatInfo,
        infoTitle
    } from '../../api/todo';
    import router from '../../router';

    export default {
        props: {
            todo: {
                required: true
            },
            client: {
                required: true
            }
        },
        components: {
            Loader
        },
        data() {
            return {
                doing: false,
                msgManager: msgManager
            };
        },
        methods: {
            infoTitle,
            formatInfo,
            markDone: async function (undo = false) {
                if (this.doing) {
                    return;
                }

                this.doing = true;

                try {
                    await markDone(this.todo.id, undo);
                    updateCount();
                    Vue.set(this.todo, 'done', !undo);

                    this.msgManager.push(
                        'Succès.',
                        undo
                            ? 'La tache a bien été restaurée'
                            : 'La tâche a bien été ignorée',
                        'success'
                    );
                } catch (e) {
                    this.msgManager.push(
                        'Erreur.',
                        e,
                        'danger'
                    );
                } finally {
                    this.doing = false;
                }
            },
            openDocument() {
                let docName;

                const attachedContract = Object.assign(
                    {},
                    this.todo.attached_contract
                );
                this.todo.info.forEach(function (info) {
                    if (info.slug === 'document_name') {
                        docName = info.value;
                    }
                });
                if (attachedContract.id) {
                    router.replace({
                        name: 'contracts-document-search',
                        params: {
                            id: this.client.id,
                            docName: docName,
                            contractId: attachedContract.id
                        }
                    });
                }

                this.$dispatch('search-document', docName);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// TodoBox.vue?7f0fc0d6